import { render, staticRenderFns } from "./StoryOneView.vue?vue&type=template&id=40bc131e&scoped=true&"
import script from "./StoryOneView.vue?vue&type=script&lang=js&"
export * from "./StoryOneView.vue?vue&type=script&lang=js&"
import style0 from "./StoryOneView.vue?vue&type=style&index=0&id=40bc131e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40bc131e",
  null
  
)

export default component.exports